import { useEffect, useRef } from "react";
import { ReviewableInput } from "ui/widgets/Input";
import type { ReviewableFormInputProps } from "./types";
import FormInputStatus, { type FormInputStatusProps } from "./FormInputStatus";

type Props = FormInputStatusProps & {
    readonly children: ReviewableFormInputProps['renderFormInput'];
};

const FormInputController = ({ children, fieldsStatuses }: Props) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const { hasAction } = ReviewableInput.useActionContext();

    const isEditing = hasAction(ReviewableInput.ReviewableAction.Edit);

    useEffect(() => {
        const timer = setTimeout(() => inputRef.current?.focus(), 100);

        return () => clearTimeout(timer);
    }, [isEditing]);

    return (
        <>
            {children({
                inputRef,
                disabled: !isEditing,
                reviewableStatus: (
                    <FormInputStatus
                        fieldsStatuses={fieldsStatuses}
                    />
                )
            })}
        </>
    );
};

export default FormInputController;
